<template>
  <div>
    <v-hover v-slot="{ hover }">
      <v-row
        no-gutters
        class="px-2 py-2"
        align="center"
        :style="{
          borderBottom: '1px solid rgba(0,0,0,0.07)',
          background: hover ? 'rgba(0,0,0,0.03)' : 'transparent',
          transition: 'background 0.15s',
        }"
      >
        <v-col cols="1">
          <v-avatar size="34">
            <v-img :src="img_url">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-icon small>mdi-palette</v-icon>
                </v-row>
              </template>
            </v-img>
          </v-avatar>
        </v-col>
        <v-col cols="4">
          <div class="text-caption grey--text mb-n1">{{ nome_serie }}</div>
          <div class="text-body-1 grey--text text--darken-3">{{ varieta.nome }}</div>
        </v-col>
        <v-col cols="3">
          <span class="grey--text text-body-1">{{ nome_colore }}</span>
        </v-col>
        <v-col cols="3" class="d-flex flex-wrap align-center">
          <div
            v-for="entry in varieta.fornitori"
            :key="entry.id"
            class="d-inline-flex align-center mr-2 mb-1"
          >
            <v-chip close @click:close="apri_conferma(entry)">
              <v-avatar left>
                <v-img :src="avatar_fornitore(entry.id_produttore)" />
              </v-avatar>
              {{ nome_fornitore(entry.id_produttore) }}
            </v-chip>
          </div>
        </v-col>
        <v-col cols="1" class="d-flex justify-end pr-1">
          <v-btn v-if="hover" small icon color="grey" @click.stop="apri_rename">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-hover>
    <v-dialog v-model="dialog_rename" width="400">
      <v-card>
        <v-card-title class="grey--text text-subtitle-1">Rinomina Varietà</v-card-title>
        <v-card-text>
          <v-text-field
            outlined
            label="Nome"
            hide-details
            v-model="nome_nuovo"
            @keypress.enter="salva_rename"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="grey" @click="dialog_rename = false">Annulla</v-btn>
          <v-btn outlined color="green" @click="salva_rename" :loading="loading_rename">Salva</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_elimina" width="400">
      <v-card>
        <v-card-title class="grey--text text-subtitle-1">Elimina Varietà</v-card-title>
        <v-card-text>
          Rimuovere <strong>{{ varieta.nome }}</strong> per il fornitore
          <strong>{{ entry_target ? nome_fornitore(entry_target.id_produttore) : '' }}</strong>?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="grey" @click="dialog_elimina = false">Annulla</v-btn>
          <v-btn outlined color="red" @click="elimina" :loading="loading_elimina">
            <v-icon class="mr-1">mdi-delete</v-icon>Elimina
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    varieta: Object,
    id_specie: String,
    series: Array,
    colori: { type: Array, default: () => [] },
  },
  data() {
    return {
      dialog_elimina: false,
      entry_target: null,
      loading_elimina: false,
      dialog_rename: false,
      loading_rename: false,
      nome_nuovo: "",
    };
  },
  computed: {
    img_url() {
      return `${process.env.VUE_APP_API_ROOT}/specie/img_colore/${this.varieta.id_colore}?t=${this.varieta.md5_colore}`;
    },
    nome_serie() {
      const s = this.series.find((s) => s.id == this.varieta.serie);
      return s ? s.nome : '—';
    },
    nome_colore() {
      const c = this.colori.find((c) => c.id == this.varieta.id_colore);
      return c ? c.nome : '';
    },
  },
  methods: {
    nome_fornitore(id) {
      return this.$store.getters.get_fornitore_by_id(id)?.nome ?? '';
    },
    avatar_fornitore(id) {
      return `${process.env.VUE_APP_API_ROOT}/fornitore/${id}/avatar`;
    },
    apri_rename() {
      this.nome_nuovo = this.varieta.nome;
      this.dialog_rename = true;
    },
    salva_rename() {
      if (!this.nome_nuovo.trim()) return;
      this.loading_rename = true;
      this.$store
        .dispatch("rename_varieta_specie", {
          id_specie: this.id_specie,
          ids: this.varieta.fornitori.map((f) => f.id),
          nome: this.nome_nuovo.trim(),
        })
        .finally(() => {
          this.loading_rename = false;
          this.dialog_rename = false;
        });
    },
    apri_conferma(entry) {
      this.entry_target = entry;
      this.dialog_elimina = true;
    },
    elimina() {
      this.loading_elimina = true;
      this.$store
        .dispatch("elimina_varieta_specie", {
          id_specie: this.id_specie,
          id_varieta: this.entry_target.id,
        })
        .finally(() => {
          this.loading_elimina = false;
          this.dialog_elimina = false;
          this.entry_target = null;
        });
    },
  },
};
</script>
